import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
@Component({
  selector: 'tools-searchable-combobox',
  templateUrl: './searchable-combobox.component.html',
  styleUrls: ['./searchable-combobox.component.scss']
})
export class SearchableComboboxComponent implements OnInit, OnChanges {
  @Output() notify: EventEmitter<any> = new EventEmitter<string>();
  @Output() allSelectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() comboboxHeading: string;
  @Input() comboboxPlaceholderName: string;
  @Input() isRequired = true;
  @Input() multipleAllowed = true;
  @Input() unFilteredOptions: any = [];
  @Input() preSelected: any;
  @Input() MenuClass: string = "";
  @Input() column = 'name';
  @Input() IDcolumn: string = null;
  @Input() disabled: boolean = false;
  @Input() additionalColumn: string = null;
  @Input() allAllowed: boolean = true;
  @Input() ID: string = null;
  comboboxControl = new UntypedFormControl();
  comboboxFilterCtrl = new UntypedFormControl();
  filteredOptions: any = [];
  allSelected = true;
  previousDisabled: Boolean = null;
  isAllSelected: boolean = false;

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["preSelected"] != null && changes["preSelected"]["currentValue"] != changes["preSelected"]["previousValue"]) {
      this.preSelected = changes["preSelected"]["currentValue"];
    }

    if (this.previousDisabled != this.disabled) {
      this.previousDisabled = this.disabled;
      if (this.disabled) {
        this.comboboxControl.disable();
      } else {
        this.comboboxControl.enable();
      }
    }
  }

  ngOnInit() {
    this.previousDisabled = this.disabled;
    if (this.disabled) {
      this.comboboxControl.disable();
    }
    if (this.multipleAllowed) {
      this.allSelected = this.preSelected && this.preSelected.length !== 0 && this.unFilteredOptions.length === this.preSelected.length;
    } else {
      this.allSelected = false;
    }
    this.filteredOptions = this.unFilteredOptions;
    if (this.allSelected && this.allAllowed) {
      this.comboboxControl.setValue([-1]);
    } else {
      if (this.preSelected != null) {
        if (this.multipleAllowed) {
          let values = [];
          this.preSelected.forEach(preSel => {
            this.filteredOptions.forEach(element => {
              if (preSel[this.IDcolumn != null ? this.IDcolumn : this.column] == element[this.IDcolumn != null ? this.IDcolumn : this.column]) {
                values.push(element);
              }
            });
          });
          this.comboboxControl.setValue(values);
        } else {

          this.preSelected.forEach(preSel => {
            this.filteredOptions.forEach(element => {

              if (preSel[this.IDcolumn != null ? this.IDcolumn : this.column] == element[this.IDcolumn != null ? this.IDcolumn : this.column]) {
                this.comboboxControl.setValue(element);
              }
            });
          });
        }
      }
    }

  }


  public selectOption(option: string) {
    if (option != "") {
      let values = this.comboboxControl.value;
      let found = false;
      for (let i = 0; i < values.length && !found; i++) {
        if (values[i][this.IDcolumn != null ? this.IDcolumn : this.column] == option) {
          found = true;
        }
      }
      if (!found) {
        this.filteredOptions.forEach(element => {
          if (option === element[this.IDcolumn != null ? this.IDcolumn : this.column]) {
            values.push(element);
          }
        });
        this.comboboxControl.setValue(values);
        this.notify.emit(this.comboboxControl.value);
      }
    }
  }

  toggleAll() {
    this.isAllSelected = !this.isAllSelected;
  }

  checkFirst() {
    if (this.filteredOptions != null && this.filteredOptions.length > 0) {
      this.comboboxControl.setValue(this.filteredOptions[0]);
    }
  }

  rebuildOptions() {
    this.comboboxControl.setValue('');
    this.comboboxFilterCtrl.setValue('');
    this.isAllSelected = false;
    this.filteredOptions = this.unFilteredOptions;
  }

  resetList() {
    this.comboboxControl.setValue('');
    this.unMarkAsTouched();
  }

  filterForFront(name: any) {
    if (name != null && name != "") {
      let lowerName = name.toLowerCase();
      this.filteredOptions = this.unFilteredOptions.filter((singleOption) => {
        if (singleOption) {
          return (singleOption[this.column] ? singleOption[this.column].toLowerCase().indexOf(lowerName) !== -1 : "") ||
            (singleOption[this.additionalColumn] ? singleOption[this.additionalColumn].toLowerCase().indexOf(lowerName) !== -1 : "");
        }
        return null; //kev added
      });
    } else {
      this.filteredOptions = this.unFilteredOptions;
    }
  }

  optionSelected() {
    if (this.comboboxControl.value === -1 || this.comboboxControl.value[0] === -1) {
      this.allSelectedChange.emit(true);
      this.notify.emit(this.unFilteredOptions);
    } else {
      this.allSelectedChange.emit(false);
      this.notify.emit(this.comboboxControl.value);
    }
  }
  markAsTouched() {
    this.comboboxControl.markAsTouched();
  }
  unMarkAsTouched() {
    this.comboboxControl.markAsUntouched();
  }
}
